import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { finalize, Subject, takeUntil } from 'rxjs';
import { passwordsCompareAsTheSame, passwordValidator } from '@core/validators';
import { AuthenticationService, LanguageService } from '@core/services';
import { UserCreate } from '@core/interfaces';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: [
    '../../core/Styles/AccountShared/account-styles.css',
    './register.component.css'
  ]
})
export class RegisterComponent implements OnInit, OnDestroy {
  public formSubmitAttempt: boolean = false;
  public isSubmitting: boolean = false;
  public errorMessages;
  private unsubscribe$: Subject<void> = new Subject<void>();
  private language: string = "en-US";


  registerForm: FormGroup = new FormGroup({
    firstName: new FormControl('', [
      Validators.required,
      Validators.maxLength(50),
      Validators.pattern("^[a-zA-Z\\s'-]+$")
    ]),
    lastName: new FormControl('', [
      Validators.required,
      Validators.maxLength(50),
      Validators.pattern("^[a-zA-Z\\s'-]+$")
    ]),
    phone: new FormControl('', [
      Validators.required,
      Validators.pattern(/^[0-9+\-\s()]{6,20}$/)
    ]),
    email: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.maxLength(256)
    ]),
    password: new FormControl('', [
      Validators.required,
      passwordValidator
    ]),
    confirmPassword: new FormControl('', [
      Validators.required,
    ]),
  }, [
    passwordsCompareAsTheSame('password', 'confirmPassword')
  ]);

  constructor(
    private authenticationService: AuthenticationService,
    private languageService: LanguageService
  ) {
    this.languageService.currentLanguage.subscribe(res=>this.language = res)
   }

  ngOnInit(): void { }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  get email() { return this.registerForm.get('email'); }
  get firstName() { return this.registerForm.get('firstName'); }
  get lastName() { return this.registerForm.get('lastName'); }
  get password() { return this.registerForm.get('password'); }
  get confirmPassword() { return this.registerForm.get('confirmPassword'); }
  get phone() { return this.registerForm.get('phone'); }

  submit() {
    if (this.isSubmitting) {
      return;
    }

    this.formSubmitAttempt = true;

    if (this.registerForm.valid) {
      this.isSubmitting = true;
      const formValues = { ...this.registerForm.value }

      const user: UserCreate = {
        firstName: formValues.firstName,
        lastName: formValues.lastName,
        email: formValues.email,
        password: formValues.password,
        confirmPassword: formValues.confirmPassword,
        phone: formValues.phone,
        culture: this.language
      };

      this.authenticationService.createUser(user)
        .pipe(
          takeUntil(this.unsubscribe$),
          finalize(() => this.isSubmitting = false)
        )
        .subscribe({
          next: () => { },
          error: err => {
            this.errorMessages = err;
          }
        })
    }
  }
}
